module.exports = {"data":{"dataJson":{"companyInfo":{"name":"Contemporarium","slogan":"Health-minded contemporary dining"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/contact.json
// module id = 280
// module chunks = 184662623972074